<template>
	<!-- страницы без интерфейса перечисляем здесь -->
	<router-view v-if="$store.state.is_auth !== true || $route.path.indexOf('/unsubscribe') === 0 || $route.path === '/503' || $route.path === '/user/check' || $route.path === '/email/check'"></router-view>
</template>

<script>
export default {
	name: 'unauthPage'
}
</script>



// WEBPACK FOOTER //
// unauthPage.vue?6ab6d420